import { PolygonContent } from 'app/agriculture/routes/Infra/components/content/PolygonContent';
import { LineStringContent } from 'app/agriculture/routes/Infra/components/content/LineStringContent';
import { InfraType } from 'app/agriculture/mutations/types/entityConfig';
import { isPolygonEntityType, isPolyLineEntityType } from 'app/agriculture/models/Entities';

interface GeometrySpecificContentProps {
    infraType: InfraType;
}

export function GeometrySpecificContent({ infraType }: GeometrySpecificContentProps) {
    if (isPolygonEntityType(infraType)) return <PolygonContent infraType={infraType} />;
    if (isPolyLineEntityType(infraType)) return <LineStringContent infraType={infraType} />;

    return null;
}
